import { useCallback } from "react";

// useDragSLTP — given the current position + a setter, returns an onDragLine handler.
// V2.2.0: SL can now be moved past the entry (trailing/profit-locking stops). TP
// still has to stay on the profit side.
export default function useDragSLTP(position, setPosition) {
  return useCallback((which, price) => {
    if (!position) return;
    setPosition(p => {
      if (!p) return p;
      if (which === "sl") {
        // Trailing stop allowed — no entry-side constraint anymore.
        return { ...p, stopLoss: price };
      }
      if (which === "tp") {
        if (p.type === "BUY" && price <= p.entryPrice) return p;
        if (p.type === "SELL" && price >= p.entryPrice) return p;
        return { ...p, takeProfit: price };
      }
      return p;
    });
  }, [position, setPosition]);
}
